/* bleed.tsx generated by @compiled/babel-plugin v0.37.1 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1mou1e8l%7Bmargin-block%3Avar(--ds-space-negative-200%2C-1rem)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1moukqjj%7Bmargin-block%3Avar(--ds-space-negative-150%2C-.75rem)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1moutdkl%7Bmargin-block%3Avar(--ds-space-negative-100%2C-.5rem)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1mougp71%7Bmargin-block%3Avar(--ds-space-negative-050%2C-.25rem)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1mou4pxn%7Bmargin-block%3Avar(--ds-space-negative-025%2C-.125rem)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._195g1e8l%7Bmargin-inline%3Avar(--ds-space-negative-200%2C-1rem)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._195gkqjj%7Bmargin-inline%3Avar(--ds-space-negative-150%2C-.75rem)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._195gtdkl%7Bmargin-inline%3Avar(--ds-space-negative-100%2C-.5rem)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._195ggp71%7Bmargin-inline%3Avar(--ds-space-negative-050%2C-.25rem)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._195g4pxn%7Bmargin-inline%3Avar(--ds-space-negative-025%2C-.125rem)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._vchhusvi%7Bbox-sizing%3Aborder-box%7D");
import React, { type ReactNode } from 'react';
import type { BasePrimitiveProps, BleedSpaceToken } from './types';
export type BleedProps = {
  /**
   * Elements to be rendered inside the Flex.
   */
  children: ReactNode;
  /**
   * Bleed along both axis.
   */
  all?: BleedSpaceToken;
  /**
   * Bleed along the inline axis.
   */
  inline?: BleedSpaceToken;
  /**
   * Bleed along the block axis
   */
  block?: BleedSpaceToken;
} & BasePrimitiveProps;

// NOTE: This maintains a full map of 10 styles as Bleed is a bit of a semantic outlier
const styles = {
  root: "_vchhusvi",
  'inline.space.025': "_195g4pxn",
  'inline.space.050': "_195ggp71",
  'inline.space.100': "_195gtdkl",
  'inline.space.150': "_195gkqjj",
  'inline.space.200': "_195g1e8l",
  'block.space.025': "_1mou4pxn",
  'block.space.050': "_1mougp71",
  'block.space.100': "_1moutdkl",
  'block.space.150': "_1moukqjj",
  'block.space.200': "_1mou1e8l"
};

/**
 * __Bleed__
 *
 * `Bleed` is a primitive layout component that controls negative whitespace.
 *
 * - [Examples](https://atlassian.design/components/primitives/bleed/examples)
 * - [Code](https://atlassian.design/components/primitives/bleed/code)
 */
const Bleed: React.MemoExoticComponent<({
  children,
  testId,
  inline,
  block,
  all,
  xcss
}: BleedProps) => JSX.Element> = React.memo(({
  children,
  testId,
  inline,
  block,
  all,
  xcss
}: BleedProps): JSX.Element => {
  return <div className={ax([styles.root, all && styles[(`inline.${all}` as const)], inline && styles[(`inline.${inline}` as const)], all && styles[(`block.${all}` as const)], block && styles[(`block.${block}` as const)], xcss])} data-testid={testId}>
			{children}
		</div>;
});
Bleed.displayName = 'Bleed';
export default Bleed;